import { Card, Col, Row, Modal, Button } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ActionsLog from "../../../../components/common/ActionsLog";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import Emails from "../../../../components/common/Emails";
import Letters from "../../../../components/common/Letters";
import Notes from "../../../../components/common/Notes";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import Texts from "../../../../components/common/Texts";
import UpcomingActivities from "../../../../components/common/UpcomingActivities";
import AccountingInformation from "../../components/AccountingInformation";
import FederalTax from "../../components/FederalTax";
import MaintenanceInformation from "../../components/MaintenanceInformation";
import OnlinePayables from "../../components/OnlinePayables";
import PersonalInformation from "../../components/PersonalInformation";
import OwnerPacket from "../../components/OwnerPacket";
import OwnerPortals from "../../components/OwnerPortals";
import OwnerStatement from "../../components/OwnerStatement";
import PropertiesOwned from "../../components/PropertiesOwned";
import Contact from "../../components/Contact";
import Email from "../../../../components/common/Email";
import { tableData } from "../ownersData";
import users from "../../../../assets/images/users.png";
import { auth, db } from "../../../../firebase";
import {
  getDocs,
  collection,
  doc,
  getDoc,
  query,
  where,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import "./OwnerDetails.css";

function OwnerDetails() {
  const [testData, setTestData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [renderData, setRenderData] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [notes, setNotes] = useState([]);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const [isHideOwner, setIsHideOwner] = useState(false);
  const showHideOwnerConfirm = () => {
    setIsHideOwner(true);
  };
  const handleOk = () => {
    setIsHideOwner(false);
  };
  const handleCancel = () => {
    setIsHideOwner(false);
  };
  const { id } = useParams();

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
          setIsCompanyNameFetched(true);
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
    console.log("useEffect......", companyName);
  }, [user, loading]);

  const getOwners = async () => {
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertiesRef = collection(companyDocRef, "owners");
      const querySnapshot = await getDocs(propertiesRef);
      const desiredId = id;

      querySnapshot.forEach((doc) => {
        if (doc.id === desiredId) {
          const propertyData = doc.data();
          const propertyWithId = { id: doc.id, ...propertyData };
          setTestData(propertyWithId);
          // updateData(false);
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  const renderingData = (data) => {
    setRenderData(data);
    console.log(data);
  };

  useEffect(() => {
    if (!isCompanyNameFetched) return;

    getOwners();

    console.log("this is useEffect Owner LIst item page..");
  }, [companyName, isCompanyNameFetched]);

  const OwnerDetailsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod("New Owner", "1", "", "", "/people/owners/new"),
      RightBarMethod(
        "New Management Agreement",
        "2",
        "",
        "",
        "/management_agreement_documents/new"
      ),
      RightBarMethod(
        <span onClick={showHideOwnerConfirm}>Hide Owner</span>,
        "3",
        "",
        "",
        ""
      ),
      RightBarMethod("Manage Owner Packets", "4", "", "", ""),
      RightBarMethod("View Owner Portal", "5", "", "", ""),
      RightBarMethod("Reset Owner Portal 2FA", "6", "", "", ""),
      RightBarMethod(
        <span onClick={showModal}>Email Owner</span>,
        "7",
        "",
        "",
        ""
      ),
      RightBarMethod("Download Text History", "8", "", "", ""),
      RightBarMethod(
        "Send Owner Packets",
        "9",
        "",
        "",
        "/communication/letters_templates/send_owner_packets"
      ),
      RightBarMethod(
        "Bulk Update Owner Packet Settings",
        "10",
        "",
        "",
        "/reporting/bulk-update-owner-packet-settinsg"
      ),
    ]),
    RightBarMethod(
      "LETTERS",
      "t2",
      <i className="fa-solid fa-file-lines"></i>,
      [
        RightBarMethod("Owner Statement (Enhanced)", "11", "", "", "/"),
        RightBarMethod("Owner Statement", "12", "", "", "/"),
        RightBarMethod("Print Envelope", "13", "", "", "/"),
      ]
    ),
    RightBarMethod(
      "HELP TOPICS",
      "t3",
      <i className="fa-solid fa-circle-question"></i>,
      [
        RightBarMethod("How to Pay Owners", "14", "", "", "/"),
        RightBarMethod("Owner Portal Overview", "15", "", "", "/"),
        RightBarMethod(
          "Management Agreements",
          "16",
          "",
          "",
          "/generalsettings/management-agreement-templates"
        ),
      ]
    ),
  ];
  console.log("testData", testData);

  return (
    <>
      <Row gutter={[0, 24]} className="owner-details">
        <Col span={24}>
          <Row gutter={[24, 0]}>
            <Col span={4}>
              <Card>
                <div className="profile-container">
                  <img src={users} alt="" />
                  <p className="silver-text">Owner</p>
                </div>
              </Card>
            </Col>
            <Col span={20}>
              {testData && (
                <PersonalInformation
                  renderData={renderingData}
                  data={testData?.ownerInfo}
                  companyName={companyName}
                  peopleType="Owner"
                  collection="owners"
                />
              )}
            </Col>
          </Row>
        </Col>
        <Col span={24}>{/* <UpcomingActivities /> */}</Col>
        <Col span={24}>
          <Contact
            renderData={renderingData}
            companyName={companyName}
            data={testData}
            peopleType="Owner"
            collectionName="owners"
          />
        </Col>
        <Col span={24}>
          <OwnerPortals
            renderData={renderingData}
            companyName={companyName}
            data={testData}
          />
        </Col>
        <Col span={24}>
          <FederalTax
            renderData={renderingData}
            companyName={companyName}
            data={testData?.federalTax}
            peopleType="Owner"
          />
        </Col>
        <Col span={24}>
          <AccountingInformation
            renderData={renderingData}
            companyName={companyName}
            data={testData?.accountingInfo}
          />
        </Col>
        <Col span={24}>
          <OnlinePayables
            renderData={renderingData}
            companyName={companyName}
            data={testData?.onlinePayables}
            peopleType="Owner"
          />
        </Col>
        <Col span={24}>
          <OwnerStatement
            renderData={renderingData}
            companyName={companyName}
            data={testData?.ownerStatement}
          />
        </Col>
        <Col span={24}>
          <OwnerPacket
            renderData={renderingData}
            companyName={companyName}
            data={testData?.ownerPacket}
          />
        </Col>
        {/* <Col span={24}>
          <PropertiesOwned
            renderData={renderingData}
            companyName={companyName}
            data={testData}
          />
        </Col> */}
        <Col span={24}>
          <MaintenanceInformation
            renderData={renderingData}
            companyName={companyName}
            data={testData?.maintenanceInformation}
          />
        </Col>
        <Col span={24}>
          {companyName ? (
            <Notes
              notesForCollection="owners"
              notesForCollectionId={testData?.id}
              companyName={companyName}
              notes={notes}
              setNotes={setNotes}
            />
          ) : null}
        </Col>
        {/* <Col span={24}>
          <Texts />
        </Col>
        <Col span={24}>
          <Emails />
        </Col>
        <Col span={24}>
          <Letters />
        </Col>
        <Col span={24}>
          <ActionsLog />
        </Col> */}
        <Col span={24}>
          {companyName ? (
            <AttachmentsUpload
              id={id}
              data={testData?.attachments}
              companyName={companyName}
              collection="owners"
            />
          ) : null}
        </Col>
      </Row>
      <div className="RightSidebar">
        <RightBar RightBarData={OwnerDetailsRightBar} />
      </div>
      <Email
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        emailTo="owner"
      />
      <Modal
        title="1 Warning"
        centered
        open={isHideOwner}
        footer={
          <div style={{ display: "flex", justifyContent: "start" }}>
            <Button type="primary" onClick={handleOk}>
              Hide
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
          </div>
        }
      >
        <p>Are you sure you want to hide this owner?</p>
      </Modal>
    </>
  );
}

export default OwnerDetails;
